import React from 'react';
import PropTypes from 'prop-types';
import { capitalize, trim, snakeCase, groupBy } from 'lodash';

import {
    Popover,
    Typography,
    makeStyles
} from '@material-ui/core';

const propTypes = {
    data: PropTypes.object.isRequired,
    anchorEl: PropTypes.object,
    onPopoverClose: PropTypes.func.isRequired
};

const defaultProps = {
    anchorEl: undefined
};

const useStyles = makeStyles((theme) => styles(theme));

function ConstraintPopover ({ data, anchorEl, onPopoverClose }) {
    const classes = useStyles();

    function humanise(str) {
        return capitalize(str.replace(/_/g, ' '));
    }

    function getName(result) {
        if(result.facetScoreName) {
            switch (result.type) {
                case 'area':
                case 'count':
                    return `${result.facetScoreName} (Intersect)`;
                case 'distance':
                    return `${result.facetScoreName} (Distance)`;
                default:
                    console.error('Unidentified result type');
                    return result.facetScoreName;
            }
        } else {
            // simple humanise
            capitalize(result.id.replace(/_/g, ' '));
        }
    }

    function risks () {
        const rr = data.weightings.results.filter(r =>  r.score !== 0);
        const groups = groupBy(rr, (r => r.risk || (r.score > 0 ? 'Positive' : 'Caution')));
        const groupKeys = ['Very High Risk', 'High Risk', 'Medium Risk', 'Low Risk', 'Very Low Risk', 'Caution', 'Positive'].filter(e => groups[e]);
        return groupKeys.map(key => (
            <div key={key}>  
                <Typography color="textPrimary" variant="h4">
                    {`${key} (${groups[key].length})`}
                </Typography>
                { 
                    groups[key].map(r => (
                        <Typography key={r.id} color="textPrimary">
                            {getName(r)}
                        </Typography>)
                    )
                }
            </div>
        ));
    }

    return (
        <Popover
            classes={{ root: classes.popover, paper: classes.paper }}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'center',
                horizontal: -10,
            }}
            onClose={onPopoverClose}
            disableRestoreFocus
        >
            {risks()}
        </Popover>
    );
}

const styles = theme => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: 10
    }
});

ConstraintPopover.propTypes = propTypes;
ConstraintPopover.defaultProps = defaultProps;

export default ConstraintPopover;